import {Component, OnInit} from '@angular/core';
import {UserService, Role} from '@cnj/uikit';
import {environment} from './environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public name = environment.settings.name;
  public production = environment.settings.production;
  public versao = environment.settings.version;
  public title = environment.settings.title;
  public api = environment.settings.api;

  constructor(protected userService: UserService) {
  }

  ngOnInit() {
    // Se sua aplicação é publicada em servidor que suporta HTTPS e deseja que utilize recursos PWA (adicionar à tela inicial/instalação)
    // ative esta variável. Mais detalhes em: https://developers.google.com/web/progressive-web-apps
    const estaAplicacaoSuportaHttpsEmProducao = false;
    // if is not localhost
    if (!(location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname === '')) {
      // if is not in https
      if (location.protocol !== 'https:' && estaAplicacaoSuportaHttpsEmProducao) {
        // redirect to https (pwa requirement)
        location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
      }
    }
  }

  showDetails() {
    console.table(environment.settings)
  }

  // Metodo que deverá obter as informações de acesso para verificar se o perfil no caso, deverá renderizar ou não o item de Menu.
  // TODO - Aguardando uma solução para esta situação, para que possa esconder os menus nos quais não exista autorização para acesso a tela.
  isAcessAuthorizationItenMenu(){
    return true;
  }

}
